import { defaultConfig } from './dynamic-configs/detail-page-config/default-detal-page-config';
import { ProductListConfigurationKeys } from './product-list-rules';

// tslint:disable-next-line:variable-name
export const ProductListConfiguration = {
  [ProductListConfigurationKeys.AllowEditionListsNotOwned]: false,
  [ProductListConfigurationKeys.CommercialListValidationMessageDisplaySizeId]:
    false,
  [ProductListConfigurationKeys.DynamicLayoutBuilderEnabled]: false,
  [ProductListConfigurationKeys.ListPageLayoutSchemas]:
    JSON.stringify(defaultConfig),
  [ProductListConfigurationKeys.ProductAutocompletePreferMasterProductId]:
    false,
  [ProductListConfigurationKeys.ProductIdFormat]: ['displayedProductId'],
  [ProductListConfigurationKeys.ProductTitleFormat]: ['articleTitle'],
  [ProductListConfigurationKeys.ShowDescriptionEditor]: false,
  [ProductListConfigurationKeys.AllowExportGrouping]: false,
};
